import { realApi } from './api';

// Cuadrante de pistas de una jornada real (temporada_id + jornada, día
// físico compartido por todas las modalidades y por su IDA/VUELTA — ver
// docs/PLAN_COMPETICION_PISTAS.md y badminton-api/docs/DOCUMENTACION_BD.md
// §2/§4. roundRobin.ts no reinicia la numeración en la vuelta, así que el
// mismo número de jornada puede ser IDA para una modalidad y VUELTA para
// otra: no lleva tipo). Se ve exista o no publicación todavía; a
// diferencia de getPistasPublicadas, esta es para /dashboard.
export const getPistasJornada = (temporadaId, jornada) =>
  realApi.get(`/temporadas/${encodeURIComponent(temporadaId)}/jornadas/${jornada}/pistas`).then((r) => r.datos);

// Lado público: null mientras el ADMIN no haya pulsado publicar (o tras un
// reset, que despublica).
export const getPistasPublicadas = (temporadaId, jornada) =>
  realApi
    .get(`/temporadas/${encodeURIComponent(temporadaId)}/jornadas/${jornada}/pistas-publicadas`)
    .then((r) => r.datos);

// Todas las jornadas publicadas de la temporada en una sola petición:
// [{ jornada, publicado, publicadoEn, disponibilidad, partidos }]. Las no
// publicadas no aparecen.
export const getPistasPublicadasTemporada = (temporadaId) =>
  realApi.get(`/temporadas/${encodeURIComponent(temporadaId)}/pistas-publicadas`).then((r) => r.datos);

// Reemplaza todos los tramos reservados de la jornada real de una vez
// (borra e inserta) — no hay edición fila a fila. tramos: [{ pista,
// horaInicio, horaFin }].
export const reemplazarDisponibilidad = (temporadaId, jornada, tramos) =>
  realApi.put(`/temporadas/${encodeURIComponent(temporadaId)}/jornadas/${jornada}/disponibilidad-pista`, { tramos });

// Partidos de una jornada (normalmente futura) que se pueden adelantar al cuadrante de otra:
// pendientes, sin WO ni jugar, sin colocar y sin participantes descalificados. Solo ADMIN.
export const getAdelantables = (temporadaId, jornada) =>
  realApi.get(`/temporadas/${encodeURIComponent(temporadaId)}/jornadas/${jornada}/adelantables`).then((r) => r.datos);

// { pista, horaInicio, horaFin } los tres a la vez, o los tres null para
// desasignar (se borra la fila en asignacion_pista). `jornadaCuadrante` (opcional)
// coloca el partido en el cuadrante de una jornada anterior a la suya (adelantado):
// el partido conserva su jornada y pasa a jugarse en la fecha de ese cuadrante.
export const asignarPista = (partidoId, datos) =>
  realApi.put(`/partidos/${partidoId}/pista`, datos);

export const publicarJornada = (temporadaId, jornada) =>
  realApi.post(`/temporadas/${encodeURIComponent(temporadaId)}/jornadas/${jornada}/publicar`);

// Vacía el reparto y despublica en la misma operación (ver §2.7 del plan).
export const resetearJornada = (temporadaId, jornada) =>
  realApi.post(`/temporadas/${encodeURIComponent(temporadaId)}/jornadas/${jornada}/resetear`);

// Fecha y sede de cada jornada real de la temporada: [{ jornada, fecha
// ('YYYY-MM-DD'|null), sede|null }]. Público (cabecera de las descargas).
export const getDatosJornadas = (temporadaId) =>
  realApi.get(`/temporadas/${encodeURIComponent(temporadaId)}/jornadas-datos`).then((r) => r.datos);

// fecha y sede nulas = sin datos (borra la fila). ADMIN o COMITE.
export const guardarDatosJornada = (temporadaId, jornada, { fecha, sede }) =>
  realApi.put(`/temporadas/${encodeURIComponent(temporadaId)}/jornadas/${jornada}/datos`, { fecha, sede });
